@if (signeringInfo) {
  <rask-cards>
    <rask-card [size]="4" [renderRaskheader]="false">
      <div class="kontrakt-container">
        <div class="kontrakt-item">
          <div class="d-flex">
            <div class="d-flex flex-column">
              @if (isSigned()) {
                <div>
                    <a
                    href="javascript:void(0)"
                    (click)="openDokument(signeringInfo.kontraktId, signeringInfo.kontraktDokumentId)"
                    class="fw-bold">{{signeringInfo.dokumentNamn}}</a>
                    <a href="javascript:void(0)" (click)="downloadDokument(signeringInfo.kontraktId, signeringInfo.kontraktDokumentId, signeringInfo.dokumentNamn)"
                    class="btn btn-lg btn-icon" title="Ladda ner dokumentet">
                    <span class="fas fa-download fa-xs"></span>
                    </a>
                </div>
              }
              @else {
              <span>{{signeringInfo.dokumentNamn}}</span>
            }
            <div>
              Version {{ signeringInfo.skickadDokumentVersion }},
              {{signeringInfo.dokumentSkapadDatum | date}}
            </div>
          </div>
          <div class="ms-auto">
            <ng-template #tpl>
              <div class="menu-btn-container">
                <rask-action-button
                  class="col-12"
                  icon="fas fa-sync-alt"
                  [disabled]="!canUpdateStatus()"
                  aid="button-uppdatera"
                (click)="updateStatus()">Uppdatera status</rask-action-button>
                <rask-action-button
                  class="col-12"
                  icon="fas fa-undo"
                  [disabled]="!canWithdraw()"
                  aid="button-aterkalla"
                (click)="withdrawDocument()">Återkalla</rask-action-button>
                <rask-action-button
                  class="col-12"
                  icon="fas fa-bell"
                  aid="button-reminder"
                  [disabled]="!canSendReminder()"
                (click)="sendReminder()">Skicka påminnelse</rask-action-button>
                <rask-action-button
                  class="col-12"
                  icon="fas fa-forward"
                  aid="button-prolong"
                  [disabled]="!canProlong()"
                (click)="prolongSigning()">Förläng förfallodatum</rask-action-button>
              </div>
            </ng-template>
            @if (signeringInfo.hasPassedSigningDay) {
              <rask-icon icon="far fa-exclamation-square warning"></rask-icon>
            }
            @if (showEndDate()) {
              <rask-span ngbTooltip="Förfallodatum">{{signeringInfo.forfalloDatumFormated}}</rask-span>
            }
            <rask-icon class="signing-icon" [icon]="getStatusIcon()" [clickToOpen]="true"
              [ngbPopover]="deltagarelista">
            </rask-icon>
            @if (!readonly) {
              <rask-menu-button class="signing-menu" [template]="tpl" #menu>
              </rask-menu-button>
            }
          </div>
        </div>
        <rask-toggle-panel label="Bilagor">
          @for (item of signeringInfo.bilagor; track $index; let first = $first) {
            <div class="d-flex flex-column" [ngClass]="{'mt-2': !first}">
              @if (isSigned()) {
                <div>
                    <a href="javascript:void(0)"
                    (click)="openDokument(signeringInfo.kontraktId, item.dokumentId)"
                    class="fw-bold">{{item.namn}}</a>
                    <a href="javascript:void(0)" (click)="downloadDokument(signeringInfo.kontraktId, item.dokumentId, item.namn )"
                        class="btn btn-lg btn-icon" title="Ladda ner dokumentet">
                        <span class="fas fa-download fa-xs"></span>
                    </a>
                </div>
              } @else {
                <span>{{item.namn}}</span>
                <span>Version {{ item.dokumentVersion }}, {{item.skapadDatum | date}}</span>
              }
            </div>
          }
        </rask-toggle-panel>
      </div>
    </div>
  </rask-card>
</rask-cards>
}

<ng-template #deltagarelista>
  <rask-container-block>
    <ng-container header>Deltagare ({{signeringInfo.deltagare.length}})</ng-container>
    <rask-list [data]="signeringInfo.deltagare" [showHeader]="true">
      <rask-list-column header="Namn" field="deltagarNamn"></rask-list-column>
      <rask-list-column header="Mottagare" field="inbjudningsOrdning"></rask-list-column>
      <rask-list-column header="Signerat" field="signeratDatum"></rask-list-column>
      <rask-list-column header="Visat" field="visatDatum"></rask-list-column>
      <rask-list-column header="Avvisat" field="avvisatDatum">
        <ng-template let-row="row">
          <rask-span [ngbTooltip]="row.avvisatMeddelande">{{row.avvisatDatum}}</rask-span>
        </ng-template>
      </rask-list-column>
      <rask-list-column header="status" field="">
        <ng-template let-row="row">
          <rask-icon [icon]="getDeltagareSigneringStatus(row)" [text]="getStatusPopOverText(row)" [clickToOpen]="false"></rask-icon>
        </ng-template>
      </rask-list-column>
    </rask-list>
  </rask-container-block>
</ng-template>
